import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function WordSearch() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="WordSearch" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Word Search</h1>
      <img
        src="/thumbnails/WordSearch.png"
        alt="Word Search game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Word Search</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Word Search is a classic puzzle game where players search for hidden words in a grid of letters. Words can be placed horizontally, vertically, or diagonally, and may appear forwards or backwards. It’s a fun way to improve your vocabulary and pattern recognition skills!
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Scan the letter grid to find the listed words hidden in all directions.</li>
          <li>Click and drag to highlight words as you find them.</li>
          <li>Words may be placed horizontally, vertically, or diagonally, and can be forwards or backwards.</li>
          <li>Complete the puzzle by finding all the words before time runs out (if playing with a timer).</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Multiple grid sizes and difficulty levels</li>
          <li>Colorful, easy-to-read letter grids</li>
          <li>Timer and untimed modes</li>
          <li>Play solo or with friends in multiplayer mode</li>
          <li>Expanding word lists for endless puzzles</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Look for unique letter combinations to spot words quickly.</li>
          <li>Scan the grid in all directions—don’t forget diagonals and backwards words!</li>
          <li>Start with the longest or most unusual words for an easier time.</li>
          <li>Practice makes perfect—your speed and accuracy will improve over time.</li>
        </ul>
      </section>
      <div className="flex justify-center mt-8">
        <PlayGameLink game="WordSearch" />
      </div>
    </div>
  );
}
